import React, { useState, useEffect } from "react";
import { NavLink, useLocation } from "react-router-dom";
import "../Styles/NavBar.css";
import logo from "../Images/logoIcon.png";
import NavBook from "./NavBook";

const Navbar = () => {
  const [menuOpen, setMenuOpen] = useState(false);
  const location = useLocation();

  // Close menu on route change
  useEffect(() => {
    setMenuOpen(false);
  }, [location.pathname]);

  // Close menu when switching to desktop
  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth > 768) {
        setMenuOpen(false);
      }
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  // Active class helper
  const navClass = ({ isActive }) => (isActive ? "nav-active" : "");

  return (
    <nav className="navbar">
      {/* Brand */}
      <div className="brand">
        <img src={logo} alt="Logo" className="logo" />
        <span>Dhotrad's Sunny Dental and Orthodontic Clinics</span>
      </div>

      {/* Hamburger */}
      <div
        className="hamburger"
        onClick={() => setMenuOpen((prev) => !prev)}
        aria-label="Toggle menu"
      >
        <span />
        <span />
        <span />
      </div>

      {/* Navigation */}
      <ul className={`nav-links ${menuOpen ? "show" : ""}`}>
        <li>
          <NavLink to="/" end className={navClass}>
            Home
          </NavLink>
        </li>
        <li>
          <NavLink to="/services" className={navClass}>
            Services
          </NavLink>
        </li>
        <li>
          <NavLink to="/aboutus" className={navClass}>
            About
          </NavLink>
        </li>
        <li>
          <NavLink to="/blogs" className={navClass}>
            Blogs
          </NavLink>
        </li>
        <li>
          <NavLink to="/patient-safety" className={navClass}>
            Patient Safety
          </NavLink>
        </li>
        <li>
          <NavLink to="/dental-tourism" className={navClass}>
            Dental Tourism
          </NavLink>
        </li>
        <li>
          <NavLink to="/contactus" className={navClass}>
            Contact
          </NavLink>
        </li>

        {/* Mobile-only button */}
        <li className="mobile-book">
          <NavBook />
        </li>
      </ul>

      {/* Desktop-only button */}
      <div className="desktop-book">
        <NavBook />
      </div>
    </nav>
  );
};

export default Navbar;
